module.exports = __webpack_public_path__ + "static/gallery-img-21-971ca1531c86fc0fa9f1b6d5f08f5523.jpg";